var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loadingContainer",staticClass:"filterOverlay"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"container min-width"},[_c('navigation'),_c('section',{attrs:{"id":"ReportNotFound"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }